(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_pincode-checker"] && !Shopify.designMode) return;
  try {
    function initPincodeChecker() {
    document.querySelectorAll('.ens-pincode-checker').forEach(function(wrapper) {
      if (wrapper._init) return;
      wrapper._init = true;

      var input = wrapper.querySelector('.ens-pincode-checker__input');
      var btn = wrapper.querySelector('.ens-pincode-checker__btn');
      var result = wrapper.querySelector('.ens-pincode-checker__result');

      if (!input || !btn || !result) return;

      var MSG_SUCCESS = wrapper.getAttribute('data-msg-success') || 'Product can be delivered here';
      var MSG_UNAVAILABLE = wrapper.getAttribute('data-msg-unavailable') || 'Sorry, delivery is not available in this area';
      var MSG_INVALID = wrapper.getAttribute('data-msg-invalid') || 'Please enter a valid 6-digit pincode';

      input.addEventListener('input', function() {
        this.value = this.value.replace(/[^0-9]/g, '');
        if (!result.hidden) { result.hidden = true; } // clear stale result while editing
      });

      btn.addEventListener('click', function() {
        var pin = input.value.trim();

        if (pin.length !== 6) {
          result.hidden = false;
          result.className = 'ens-pincode-checker__result ens-pincode-checker__result--error';
          result.textContent = MSG_INVALID;
          return;
        }

        var validPins = [
          '400001','400002','400003','400004','400005','400006','400007','400008','400009','400010',
          '400011','400012','400013','400014','400015','400016','400017','400018','400019','400020',
          '400021','400022','400023','400024','400025','400026','400027','400028','400029','400030',
          '400031','400032','400033','400034','400035','400036','400037','400038','400039','400040',
          '400041','400042','400043','400044','400045','400046','400047','400048','400049','400050',
          '400051','400052','400053','400054','400055','400056','400057','400058','400059','400060',
          '400061','400062','400063','400064','400065','400066','400067','400068','400069','400070',
          '400071','400072','400073','400074','400075','400076','400077','400078','400079','400080',
          '400081','400082','400083','400084','400085','400086','400087','400088','400089','400090',
          '400091','400092','400093','400094','400095','400096','400097','400098','400099','400100',
          '400101','400102','400103','400104','400105','400106','400107','400108',
          '410206','410207','410208','410209','410210',
          '421001','421002','421003','421004','421005','421006','421007','421008',
          '421101','421102','421103','421104','421201','421202','421203','421204',
          '421301','421302','421303','421304','421305','421306',
          '421501','421502','421503','421504','421505','421506',
          '421601','421602','421603','421604','421605',
          '400601','400602','400603','400604','400605','400606','400607','400608',
          '400701','400702','400703','400704','400705','400706','400707','400708','400709','400710',
          '401101','401102','401103','401104','401105','401106','401107',
          '401201','401202','401203','401204','401205','401206','401207','401208',
          '401209','401210','401301','401302','401303','401304','401305',
          '401401','401402','401403','401404','401405'
        ];

        if (validPins.indexOf(pin) !== -1) {
          result.hidden = false;
          result.className = 'ens-pincode-checker__result ens-pincode-checker__result--success';
          result.textContent = MSG_SUCCESS;
        } else {
          result.hidden = false;
          result.className = 'ens-pincode-checker__result ens-pincode-checker__result--error';
          result.textContent = MSG_UNAVAILABLE;
        }
      });

      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          btn.click();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPincodeChecker);
  } else {
    initPincodeChecker();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["logo"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    const link = e.target.closest('[data-scroll-top="true"]');
    if (!link) return;

    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  } catch(e) { console.error(e); }
})();

})();
